import { ImpersonatedBuyer, User } from '@ps/auth-data-access';

import { RouteContext } from './route-context';

export interface UserContext {
  readonly user: User;
  readonly hasServiceOperatorAccess: boolean;
  readonly impersonatedBuyer: ImpersonatedBuyer | null;
}

export class RequestUser {
  private constructor(
    private readonly _userContext: UserContext,
    private readonly _requiresImpersonatedBuyerToken: boolean,
  ) {}

  public static from(
    routeContext: RouteContext,
    userContext: UserContext,
  ): RequestUser {
    return new RequestUser(
      userContext,
      routeContext.requiresImpersonatedBuyerToken(),
    );
  }

  public id(): string {
    return this._userContext.hasServiceOperatorAccess
      ? this._userContext.user.id.toString()
      : '';
  }

  public token(): string {
    if (
      this._userContext.impersonatedBuyer &&
      this._requiresImpersonatedBuyerToken
    ) {
      return this._userContext.impersonatedBuyer.token;
    }

    return this._userContext.user.token;
  }
}
